import * as React from "react";

import { showModal } from "../Component/popups"
import { BaseDialogFormComponent } from "../Component/BaseDialogFormComponent"
import { appContext } from "../App/appContext"

import { showLoginPopup } from "./Login"
import { showSetPasswordPopup } from "./SetPassword"

import Models = Gf.Web.Models;

export function showResetPasswordPopup(request: Models.ResetPasswordRequest) {
    showModal(<ResetPassword {...request} />);
}

function resetPassword(request: Models.ResetPasswordRequest, consumer: (errorMessage: string) => void): void {
    appContext.post("/Login/ResetPassword",
        request,
        (response: Models.ResetPasswordResponse) => {
            if (response.ErrorMessage) {
                consumer(response.ErrorMessage);
            } else {
                showSetPasswordPopup({
                    Username: request.Username,
                    Code: "",
                    ClickedEmailLink: false,
                    Password: "",
                    RepeatPassword: "",
                    SetName: false,
                    Name: ""
                });
            }
        });
}

class ResetPassword extends BaseDialogFormComponent<Models.ResetPasswordRequest> {
    constructor(props: Models.ResetPasswordRequest) { super(props); }
    title() { 
        return <div>
            <div>Sett et nytt passord</div>
            <small>Vi sender deg først en engangskode på e-post</small>
        </div>; 
    } 
    body() { 
        return <div>
            {this.field("E-postadresse", "Username", "username")}
            {this.link("Jeg har allerede et passord", () => showLoginPopup(this.state.model.Username))}
        </div>; 
    }
    buttons() { 
        return [
            this.button("Avbryt", "button"),
            this.button("Send meg engangskode", "submit", (consumer) => resetPassword(this.state.model, consumer), "primary")
        ];
    }
    requiredFields() { return ["Username"]; }
}



// WEBPACK FOOTER //
// ./Scripts/React/Login/ResetPassword.tsx